import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustSignal {
  icon: string;
  title: string;
  description: string;
}

const TrustSignals = () => {
  const signals: TrustSignal[] = [
    {
      icon: "ShieldCheckIcon",
      title: "GDPR Compliant",
      description: "Volledig conform Europese privacywetgeving"
    },
    {
      icon: "LockClosedIcon",
      title: "Veilige Betalingen",
      description: "SSL-versleutelde transacties"
    },
    {
      icon: "ClockIcon",
      title: "24/7 Monitoring",
      description: "Continue beschikbaarheid en uptime"
    },
    {
      icon: "UserGroupIcon",
      title: "100+ Tevreden Klanten",
      description: "Bewezen resultaten in de Benelux"
    }
  ];

  return (
    <section className="py-12 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {signals.map((signal, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-4 rounded-xl hover:bg-muted/50 transition-colors duration-300"
            >
              <div className="p-3 rounded-lg bg-primary/10 border border-primary/20 mb-3">
                <Icon name={signal.icon as any} size={24} className="text-primary" />
              </div>
              <h3 className="font-semibold text-foreground mb-1 text-sm">
                {signal.title}
              </h3>
              <p className="text-xs text-muted-foreground">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;